import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getDoctorInfo = createAsyncThunk('getDoctor/getDoctorInfo', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getDoctorProfile(payload.id);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
